export const formatPhone = (phone: string) => {
  if (phone) {
    const number = phone.replace(/\D/g, '')

    if (number.length === 10) {
      return `(${number.slice(0, 3)}) ${number.slice(3, 6)}-${number.slice(6)}`
    }
    if (number.length === 12 || number.length === 11) {
      const countryCodeLength = number.length === 11 ? 1 : 2

      return `+${number.slice(0, countryCodeLength)} (${number.slice(
        countryCodeLength,
        countryCodeLength + 3
      )}) ${number.slice(
        countryCodeLength + 3,
        countryCodeLength + 6
      )}-${number.slice(countryCodeLength + 6)}`
    }

    throw new Error('Invalid phone number')
  } else {
    return ''
  }
}

export const removeTrailingSlash = (str: string) =>
  str.endsWith('/') ? str.slice(0, -1) : str
